(() => {

    // Block Name
    const blockName = 'chart-bar';

    // Variables
    let method = 'front';
    if ( document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin') ) {
        method = 'wp-admin';
    }
    let globalCharts = {};

    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined ) block = block[0].querySelector(`.block-${blockName}`);
        if ( block === false || block === null ) return;

        // Block Code Here

        let chartData = block.id.replaceAll('-', '');
        chartData = window[chartData];
        console.log(chartData);

        if(globalCharts[block.id + '-frame']){   //check if exist chart dispose that
            globalCharts[block.id + '-frame'].dispose();
        }
        let root = am5.Root.new(block.id + '-frame');
        root.locale = am5locales_pl_PL;

        globalCharts[block.id + '-frame'] = root;

        let palette = document.querySelector('#' + block.id + '-frame').dataset.palette;
        let colors = document.querySelector('#' + block.id + '-frame').dataset.colors;
        let tooltipSettings = document.querySelector('#' + block.id + '-frame').dataset.tooltip;
        tooltipSettings = tooltipSettings.split('|');

        // root.setThemes([
        //     am5themes_Animated.new(root)
        // ]);

        let myTheme = am5.Theme.new(root);

        if( chartData.data.length < 6 ){
            myTheme.rule("AxisLabel").setAll({
                fontSize: "12px"
            });
        } else {
            myTheme.rule("AxisLabel").setAll({
                fontSize: "10px"
            });
        }

        root.setThemes([
            myTheme
        ]);

        // Custom chart settings
        let chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "none",
            wheelY: "none",
            paddingRight: 25
        }));

        // root.numberFormatter.set("numberFormat", "#");


        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        cursor.lineY.set("visible", false);

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        var yRenderer = am5xy.AxisRendererY.new(root, { minGridDistance: 10 });

        var yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
                maxDeviation: 0,
                categoryField: chartData.yLabel,
                renderer: yRenderer,
            })
        );

        var xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
                maxDeviation: 0,
                numberFormat: "#",
                // min: 0,
                renderer: am5xy.AxisRendererX.new(root, {})
            })
        );

        // let xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
        // xRenderer.labels.template.setAll({
        //     rotation: 0,
        //     centerY: am5.p50,
        //     centerX: am5.p100,
        //     paddingRight: 15
        // });

        // let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
        //     maxDeviation: 0.3,
        //     categoryField: chartData.yLabel,
        //     renderer: xRenderer,
        //     tooltip: am5.Tooltip.new(root, {})
        // }));

        // let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        //     maxDeviation: 0.3,
        //     renderer: am5xy.AxisRendererY.new(root, {})
        // }));

        // Create series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        // console.log(chartData);
        let series = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: "Series 1",
                xAxis: xAxis,
                yAxis: yAxis,
                valueXField: chartData.xLabel,
                sequencedInterpolation: true,
                categoryYField: chartData.yLabel,
                tooltip: am5.Tooltip.new(root, {
                    labelText:"{valueX}",
                })
            }
        ));


        // Set data
        let data = chartData.data;

        // -- end

        series.columns.template.setAll({
            cornerRadiusTL: 0,
            cornerRadiusTR: 0,
            stroke: 0,
            templateField: "columnSettings"
        });

        if(palette == 'single'){
            // series.columns.template.setAll({
            //     fill: colors,
            // });

            colors = colors.split(',');
            // console.log( colors );

            series.columns.template.adapters.add("fill", function(fill, target) {
                // console.log(target.dataItem.dataContext);
                if(target.dataItem.dataContext.hasOwnProperty("columnSettings")){
                    return fill;
                }
                if(target.dataItem.dataContext.chart_manual_y >= 0 || target.dataItem.dataContext.value >= 0){
                    return colors[0];
                } else {
                    return colors[1];
                }
            });

        } else {
            colors = colors.split(',');
            let colorsCount = colors.length;

            series.columns.template.adapters.add("fill", function(fill, target) {
                if(!target.dataItem.dataContext.hasOwnProperty("columnSettings")){
                    return colors[(series.columns.indexOf(target) % colorsCount)];
                } else {
                    return fill;
                }
            });
        }

        if(tooltipSettings[0] == "1"){
            if(tooltipSettings[1] == ''){
                series.columns.template.setAll({
                    tooltipText: "{categoryY}: {valueX}",
                });
            } else {
                console.log(tooltipSettings[1]);
                series.columns.template.setAll({
                    tooltipHTML: "<div style='color: " + tooltipSettings[3] + ";font-size: " + tooltipSettings[4] + "px'>" + tooltipSettings[1] + "</div>",

                });
            }

            let gFFS = true;
            let aTC = true;
            let tScale = 1;
            if( tooltipSettings[1] == ''){
                tScale = tooltipSettings[4] / 15.75;
            }
            if(tooltipSettings[2] != ''){
                gFFS = false;
            }
            if(tooltipSettings[2] != ''){
                aTC = false;
            }
            let tooltip = am5.Tooltip.new(root, {
                getFillFromSprite: gFFS,
                autoTextColor: aTC,
                scale: tScale
            });

            if(tooltipSettings[2] != ''){
                tooltip.get("background").setAll({
                    fill: tooltipSettings[2]
                });
            }

            if(tooltipSettings[3] != ''){
                tooltip.label.setAll({
                    fill: tooltipSettings[3]
                });
            }
            series.set("tooltip", tooltip);
        }

        if( block.classList.contains("white-label") ){
            let yRenderer = yAxis.get("renderer");
            let xRenderer = xAxis.get("renderer");
            yRenderer.labels.template.setAll({
                fill: am5.color(0xFFFFFF)
            });
            yRenderer.grid.template.setAll({
                stroke: am5.color(0xFFFFFF)
            });
            xRenderer.labels.template.setAll({
                fill: am5.color(0xFFFFFF)
            });
            xRenderer.grid.template.setAll({
                stroke: am5.color(0xFFFFFF)
            });
        }


        yAxis.data.setAll(data);
        series.data.setAll(data);

        // Custom legends

        // -- end
        let exporting = am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            pdfOptions: {
                disabled: true
            },
            printOptions: {
                disabled: true
            },
            pngOptions: {
                // minWidth: 1000,
                // maxWidth: 2000,
                quality: 1
            },
            jpgOptions: {
                // minWidth: 1000,
                // maxWidth: 2000,
                quality: 1
            },
            htmlOptions: {
                disabled: true
            }
        });
        block.querySelector('.am5exporting-icon').innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" fill="black"/></svg>';


        series.appear(1000);
        chart.appear(1000, 100);


    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if ( blocks.length > 0 ) {
            blocks.forEach( (block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
